<template>
  <section
    class="services-hero relative overflow-hidden"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center text-white px-6">
      <span class="eyebrow eyebrow-light mb-5">Nuestros tratamientos</span>
      <h1 class="hero-title text-5xl md:text-7xl font-bold text-white">Servicios</h1>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="mt-6 text-base md:text-xl text-white/90 max-w-2xl italic font-light">
        Cada servicio diseñado para resaltar tu estilo único
      </p>
    </div>
  </section>

  <section class="w-full max-w-6xl mx-auto px-6 py-20">
    <div
      v-for="(service, index) in services"
      :key="service.title"
      :class="['service-row', { 'service-row--reverse': index % 2 === 1 }]"
    >
      <div class="service-row__text">
        <span class="eyebrow mb-3">0{{ index + 1 }} · Servicio</span>
        <h2 class="font-display text-3xl md:text-4xl text-purple-custom font-semibold mt-2 mb-4">
          {{ service.title }}
        </h2>
        <span class="divider-line mb-5"></span>
        <p class="text-gray-700 leading-relaxed text-base md:text-lg mb-7">
          {{ service.description }}
        </p>
        <div class="flex justify-center md:justify-start">
          <router-link to="/galeria" class="btn-secondary">
            Ver más
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </router-link>
        </div>
      </div>

      <div class="service-row__image-wrapper">
        <div class="service-row__image-frame">
          <img :src="service.image" :alt="service.title" class="service-row__image" />
        </div>
      </div>
    </div>
  </section>

  <GoContacto />
</template>

<script>
import backgroundImage from "@/assets/cristal1-scaled.jpg";
import GoContacto from "@/components/GoContacto.vue";
import { useHead } from "@vueuse/head";

import imgManicure from "@/assets/Manicure/manicure8.jpg";
import imgPedicure from "@/assets/Pedicure/pedicure6.jpg";
import imgAsiatico from "@/assets/Asiatico/asiatico17.jpg";
import imgSoftgel from "@/assets/Softgel/softgel1.jpg";
import imgNovia from "@/assets/MaquillajePeinado/Maquillaje2.jpg";
import imgSocial from "@/assets/MaquillajePeinado/Maquillaje7.jpg";
import imgPeinado from "@/assets/MaquillajePeinado/Peinado6.jpg";

export default {
  components: {
    GoContacto,
  },
  name: "ServicesPage",
  setup() {
    useHead({
      title: "Servicios | Nos encanta resaltar tu estilo",
      meta: [
        {
          name: "description",
          content:
            "En Jeshu Beauty, realzamos tu belleza única con servicios personalizados y adaptados a tu estilo. Nuestro equipo de expertos combina creatividad y profesionalismo para hacerte lucir y sentir increíble.",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          content: "Servicios | Nos encanta resaltar tu estilo",
        },
        {
          property: "og:description",
          content:
            "En Jeshu Beauty, realzamos tu belleza única con servicios personalizados y adaptados a tu estilo. Nuestro equipo de expertos combina creatividad y profesionalismo para hacerte lucir y sentir increíble.",
        },
        { property: "og:url", content: "https://jeshubeauty.cl/services" },
      ],
      link: [{ rel: "canonical", href: "https://jeshubeauty.cl/services" }],
    });
  },
  data() {
    return {
      backgroundImage,
      services: [
        {
          title: "Manicure y Esmaltado",
          description:
            "Descubre la experiencia única del servicio de manicure, donde cada detalle cuenta. Utilizando técnicas profesionales y tratamientos especializados en tus manos dejando un acabado elegante y hermoso.",
          image: imgManicure,
        },
        {
          title: "Pedicure y Esmaltado",
          description:
            "Dale a tus pies el cuidado que se merecen con el servicio de pedicure. Utilizando técnicas relajantes para brindarte una experiencia renovadora. Cada paso está diseñado para realzar la belleza de tus pies.",
          image: imgPedicure,
        },
        {
          title: "Uñas Estilo Asiático y Diseños",
          description:
            "Trabajo con técnicas estilo asiático que son tanto elegantes como innovadoras para el cuidado de tus uñas. Creando así diseños únicos que reflejan tu personalidad y que estén a la moda.",
          image: imgAsiatico,
        },
        {
          title: "Soft Gel",
          description:
            "Si eres fan de las uñas largas o quieres cuidar las tuyas para que crezcan, este servicio es para ti. Son tips a base de gel flexible que se adhieren fácilmente a la superficie de la uña, con una excelente fijación por 3 semanas donde tus uñas se verán hermosas y muy naturales.",
          image: imgSoftgel,
        },
        {
          title: "Maquillaje Novia",
          description:
            "Para ese día tan especial, te ofrezco un maquillaje de novia personalizado, que realzará tu belleza única y asegurando que te sientas radiante y segura durante toda la celebración. Trabajo exclusivamente con marcas profesionales reconocidas por su calidad y resistencia, diseñadas para brindarte un acabado impecable, natural y de larga duración.",
          image: imgNovia,
        },
        {
          title: "Maquillaje Social",
          description:
            "Para ese evento de día o de noche en que necesites producirte un poco más, te ofrezco el servicio de maquillaje social, diseñado y personalizado de acuerdo a tus gustos, utilizando productos de alta gama para lograr un acabado espectacular y natural de principio a fin.",
          image: imgSocial,
        },
        {
          title: "Peinados",
          description:
            "¿Acomodar tu cabello te resulta complicado? Estoy aquí para ayudarte a lucirlo tal como deseas, para hacerte sentir cómoda, segura y hermosa. Realizo peinados simples pero llenos de estilo, ideales para eventos, celebraciones o cualquier ocasión en la que quieras verte y sentirte increíble. Trabajo con herramientas y productos profesionales que no dañarán tu cabello, pero te acompañarán durante todo tu evento.",
          image: imgPeinado,
        },
      ],
    };
  },
};
</script>

<style scoped>
.services-hero {
  height: 55vh;
  min-height: 440px;
  background-size: cover;
  background-position: center;
}

.service-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  margin-bottom: 5rem;
}

@media (min-width: 768px) {
  .service-row {
    flex-direction: row;
    gap: 4rem;
  }
  .service-row--reverse {
    flex-direction: row-reverse;
  }
}

.service-row__text {
  flex: 1;
  text-align: center;
}

@media (min-width: 768px) {
  .service-row__text {
    text-align: left;
  }
}

.service-row__image-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
}

.service-row__image-frame {
  position: relative;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 18px 44px rgba(115, 74, 145, 0.18);
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.service-row__image-frame::after {
  content: '';
  position: absolute;
  inset: 8px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 1rem;
  pointer-events: none;
  z-index: 2;
}

.service-row__image-frame:hover {
  transform: translateY(-6px);
  box-shadow: 0 28px 60px rgba(115, 74, 145, 0.28);
}

.service-row__image {
  display: block;
  height: 320px;
  width: auto;
  object-fit: cover;
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

@media (min-width: 768px) {
  .service-row__image {
    height: 420px;
  }
}

.service-row__image-frame:hover .service-row__image {
  transform: scale(1.06);
}
</style>
